import { useState } from "react";

import { useT } from "../../../shared/i18n";
import { Banner } from "../../../shared/ui";
import { adminHref } from "../adminRoute";
import { DEFAULT_LOG_FILTERS, type LogFilters } from "./logFormat";
import { LogsWorkspace } from "./LogsWorkspace";
import type { TraceApi } from "./traceApi";

/** The Logs section; the open call and the user pre-filter come from the URL. */
export function LogsPage({
  api,
  wide,
  correlationId,
  userId,
  onNavigate,
}: {
  api: TraceApi;
  wide: boolean;
  correlationId: string | null;
  /** From `?user=`: starts the list filtered by this user. */
  userId: string | null;
  onNavigate: (href: string) => void;
}) {
  const t = useT();
  const [filters, setFilters] = useState<LogFilters>(() =>
    userId
      ? { ...DEFAULT_LOG_FILTERS, userId, range: "24h" }
      : DEFAULT_LOG_FILTERS,
  );
  return (
    <section aria-label={t("admin.logs.title")} className="flex flex-col gap-3">
      <h2 className="text-title text-fg">{t("admin.logs.title")}</h2>
      <Banner tone="info">{t("admin.logs.notice")}</Banner>
      <LogsWorkspace
        api={api}
        wide={wide}
        filters={filters}
        onFiltersChange={setFilters}
        openId={correlationId}
        onOpen={(id) => {
          onNavigate(adminHref({ section: "logs", correlationId: id }));
        }}
        onClose={() => {
          onNavigate(adminHref({ section: "logs" }));
        }}
        hrefFor={(id) => adminHref({ section: "logs", correlationId: id })}
        onOpenUser={(id) => {
          onNavigate(adminHref({ section: "users", userId: id }));
        }}
      />
    </section>
  );
}
